import { LICENSE_LABEL_MESSAGE_IDS, TONE } from './constants'
import { AI_RISK_REPORT_CHANNELS, DEFAULT_AI_RISK_REPORT_CHANNEL } from './reportChannel'

const SECTION_TAG = {
  deployment: { labelId: 'AI_RISK_REPORT.SECTION.DEPLOYMENT.TITLE', tone: TONE.NEUTRAL },
  dataExposure: { labelId: 'AI_RISK_REPORT.SECTION.DATA_EXPOSURE.TITLE', tone: TONE.NEUTRAL },
  identity: { labelId: 'AI_RISK_REPORT.SECTION.IDENTITY.TITLE', tone: TONE.NEUTRAL },
  thirdParty: { labelId: 'AI_RISK_REPORT.SECTION.THIRD_PARTY.TITLE', tone: TONE.NEUTRAL },
}

const EFFORT_TAG = {
  low: { labelId: 'AI_RISK_REPORT.EFFORT.LOW', tone: TONE.NEUTRAL },
  medium: { labelId: 'AI_RISK_REPORT.EFFORT.MEDIUM', tone: TONE.NEUTRAL },
  high: { labelId: 'AI_RISK_REPORT.EFFORT.HIGH', tone: TONE.NEUTRAL },
}

const LICENSE_REQUIRED_TAG = { labelId: 'AI_RISK_REPORT.RECO.LICENSE_REQUIRED_TAG', tone: TONE.INFO }
const LICENSE_COPY = {
  titleId: 'AI_RISK_REPORT.RECO.LICENSE.TITLE',
  descriptionId: 'AI_RISK_REPORT.RECO.LICENSE.DESC',
}

const CONFIGURATION_COPY = {
  'deployment.upgradeBaseSkus': {
    titleId: 'AI_RISK_REPORT.RECO.UPGRADE_BASE_SKUS.TITLE',
    descriptionId: 'AI_RISK_REPORT.RECO.DEPLOYMENT.DESC',
  },
  'deployment.assignAddOns': {
    titleId: 'AI_RISK_REPORT.RECO.ASSIGN_ADD_ONS.TITLE',
    descriptionId: 'AI_RISK_REPORT.RECO.DEPLOYMENT.DESC',
  },
  'sharePoint.reviewConfiguration': {
    titleId: 'AI_RISK_REPORT.RECO.SHAREPOINT_REVIEW_CONFIGURATION.TITLE',
    descriptionId: 'AI_RISK_REPORT.RECO.SHAREPOINT_REVIEW_CONFIGURATION.DESC',
  },
  'sp.oversharedSites': {
    titleId: 'AI_RISK_REPORT.RECO.SP_OVERSHARED_SITES.TITLE',
    descriptionId: 'AI_RISK_REPORT.RECO.DATA_EXPOSURE.DESC',
  },
  'sp.appAccess': {
    titleId: 'AI_RISK_REPORT.RECO.SP_APP_ACCESS.TITLE',
    descriptionId: 'AI_RISK_REPORT.RECO.DATA_EXPOSURE.DESC',
  },
  'labels.deployed': {
    titleId: 'AI_RISK_REPORT.RECO.LABELS_AND_AUTO_LABELLING.TITLE',
    descriptionId: 'AI_RISK_REPORT.RECO.DATA_EXPOSURE.DESC',
  },
  'labels.autoLabelling': {
    titleId: 'AI_RISK_REPORT.RECO.AUTO_LABELLING.TITLE',
    descriptionId: 'AI_RISK_REPORT.RECO.DATA_EXPOSURE.DESC',
  },
  'labels.dlpCopilot': {
    titleId: 'AI_RISK_REPORT.RECO.DLP_COPILOT.TITLE',
    descriptionId: 'AI_RISK_REPORT.RECO.DATA_EXPOSURE.DESC',
  },
  'labels.dlpEnforced': {
    titleId: 'AI_RISK_REPORT.RECO.DLP_ENFORCED.TITLE',
    descriptionId: 'AI_RISK_REPORT.RECO.DATA_EXPOSURE.DESC',
  },
  'groups.lifecycle': {
    titleId: 'AI_RISK_REPORT.RECO.GROUP_LIFECYCLE.TITLE',
    descriptionId: 'AI_RISK_REPORT.RECO.DATA_EXPOSURE.DESC',
  },
  'groups.dynamicGuests': {
    titleId: 'AI_RISK_REPORT.RECO.DYNAMIC_GROUP_GUESTS.TITLE',
    descriptionId: 'AI_RISK_REPORT.RECO.DATA_EXPOSURE.DESC',
  },
  'dataExposure.pendingGuests': {
    titleId: 'AI_RISK_REPORT.RECO.PENDING_GUESTS.TITLE',
    descriptionId: 'AI_RISK_REPORT.RECO.DATA_EXPOSURE.DESC',
  },
  'admins.count': {
    titleId: 'AI_RISK_REPORT.RECO.ADMIN_COUNT.TITLE',
    descriptionId: 'AI_RISK_REPORT.RECO.IDENTITY.DESC',
  },
  'admins.nonHuman': {
    titleId: 'AI_RISK_REPORT.RECO.NON_HUMAN_ADMINS.TITLE',
    descriptionId: 'AI_RISK_REPORT.RECO.IDENTITY.DESC',
  },
  'admins.sharedMailbox': {
    titleId: 'AI_RISK_REPORT.RECO.SHARED_MAILBOX_ADMINS.TITLE',
    descriptionId: 'AI_RISK_REPORT.RECO.IDENTITY.DESC',
  },
  'identity.enforceMfa': {
    titleId: 'AI_RISK_REPORT.RECO.ENFORCE_MFA.TITLE',
    descriptionId: 'AI_RISK_REPORT.RECO.IDENTITY.DESC',
  },
  'identity.phishingResistantMfa': {
    titleId: 'AI_RISK_REPORT.RECO.PHISHING_RESISTANT_MFA.TITLE',
    descriptionId: 'AI_RISK_REPORT.RECO.IDENTITY.DESC',
  },
  'apps.highRiskAppRole': {
    titleId: 'AI_RISK_REPORT.RECO.HIGH_RISK_APP_ROLE.TITLE',
    descriptionId: 'AI_RISK_REPORT.RECO.THIRD_PARTY.DESC',
  },
  'apps.neverRotatingSecret': {
    titleId: 'AI_RISK_REPORT.RECO.NEVER_ROTATING_SECRET.TITLE',
    descriptionId: 'AI_RISK_REPORT.RECO.THIRD_PARTY.DESC',
  },
  'apps.broadAudience': {
    titleId: 'AI_RISK_REPORT.RECO.BROAD_AUDIENCE_APP.TITLE',
    descriptionId: 'AI_RISK_REPORT.RECO.THIRD_PARTY.DESC',
  },
  'discover.reviewAiAppUsage': {
    titleId: 'AI_RISK_REPORT.RECO.DISCOVER_REVIEW_AI_APP_USAGE.TITLE',
    descriptionId: 'AI_RISK_REPORT.RECO.DISCOVER_REVIEW_AI_APP_USAGE.DESC',
  },
  'authz.reviewConfiguration': {
    titleId: 'AI_RISK_REPORT.RECO.AUTHZ_REVIEW_CONFIGURATION.TITLE',
    descriptionId: 'AI_RISK_REPORT.RECO.AUTHZ_REVIEW_CONFIGURATION.DESC',
  },
}

const BETA_CONFIGURATION_COPY = {
  'apps.neverRotatingSecret': {
    titleId: 'AI_RISK_REPORT.BETA.RECO.LONG_LIVED_APP_SECRET.TITLE',
    descriptionId: 'AI_RISK_REPORT.RECO.THIRD_PARTY.DESC',
  },
}

const SHAREPOINT_RECOMMENDATION_IDS = new Set([
  'sharingCapability',
  'defaultSharingLinkType',
  'defaultLinkPermission',
  'isResharingByExternalUsersEnabled',
  'externalUserExpirationRequired',
  'externalUserExpireInDays',
  'isLegacyAuthProtocolsEnabled',
  'requireAnonymousLinksExpireInDays',
  'markNewFilesSensitiveByDefault',
  'enableRestrictedAccessControl',
])

const AUTHZ_RECOMMENDATION_IDS = new Set([
  'invites',
  'emailVerifiedJoin',
  'emailBasedSubscriptions',
  'riskyAppsConsent',
  'apps',
  'tenants',
  'groups',
  'guestRole',
  'permissionGrantPolicy',
])

const CA_RECOMMENDATION_TITLE_ID = {
  'ca.mfa-all-users': 'AI_RISK_REPORT.IDENTITY.CA.BASELINE.PATTERN.MFA_ALL',
  'ca.block-legacy': 'AI_RISK_REPORT.IDENTITY.CA.BASELINE.PATTERN.BLOCK_LEGACY',
  'ca.phish-admins': 'AI_RISK_REPORT.IDENTITY.CA.BASELINE.PATTERN.PHISH_ADMINS',
  'ca.signin-risk': 'AI_RISK_REPORT.IDENTITY.CA.BASELINE.PATTERN.SIGNIN_RISK',
  'ca.user-risk': 'AI_RISK_REPORT.IDENTITY.CA.BASELINE.PATTERN.USER_RISK',
  'ca.compliant-device': 'AI_RISK_REPORT.IDENTITY.CA.BASELINE.PATTERN.COMPLIANT_DEVICE',
}

const getConfigurationCopy = (id, channel) => {
  if (channel === AI_RISK_REPORT_CHANNELS.BETA && BETA_CONFIGURATION_COPY[id]) {
    return BETA_CONFIGURATION_COPY[id]
  }

  if (CONFIGURATION_COPY[id]) return CONFIGURATION_COPY[id]

  if (id.startsWith('sharePoint.')) {
    const settingId = id.replace('sharePoint.', '')
    if (SHAREPOINT_RECOMMENDATION_IDS.has(settingId)) {
      return {
        titleId: `AI_RISK_REPORT.RECO.SHAREPOINT.${settingId}.TITLE`,
        descriptionId: 'AI_RISK_REPORT.RECO.DATA_EXPOSURE.DESC',
      }
    }
  }

  if (CA_RECOMMENDATION_TITLE_ID[id]) {
    return { titleId: CA_RECOMMENDATION_TITLE_ID[id], descriptionId: 'AI_RISK_REPORT.RECO.CA.DESC' }
  }

  if (id.startsWith('authz.')) {
    const settingId = id.replace('authz.', '')
    if (AUTHZ_RECOMMENDATION_IDS.has(settingId)) {
      return {
        titleId: `AI_RISK_REPORT.RECO.AUTHZ.${settingId}.TITLE`,
        descriptionId: 'AI_RISK_REPORT.RECO.AUTHZ.DESC',
      }
    }
  }

  return null
}

const getRecommendationCopy = (recommendation, channel) =>
  recommendation.type === 'license' ? LICENSE_COPY : getConfigurationCopy(recommendation.id, channel)

export const buildRecommendationItems = (recommendations = [], channel = DEFAULT_AI_RISK_REPORT_CHANNEL) =>
  recommendations.flatMap((recommendation) => {
    const copy = getRecommendationCopy(recommendation, channel)
    if (!copy) return []

    const isLicense = recommendation.type === 'license'
    const requiredLicense = recommendation.parameters?.requiredLicense
    const values = isLicense
      ? {
          count: recommendation.parameters.affectedCount,
          licenseLabelId:
            LICENSE_LABEL_MESSAGE_IDS[requiredLicense] ?? 'AI_RISK_REPORT.LICENSE.REQUIRED_MICROSOFT_LICENSE',
        }
      : undefined
    const tags = [
      ...(isLicense ? [LICENSE_REQUIRED_TAG] : []),
      ...recommendation.sectionIds.map((sectionId) => SECTION_TAG[sectionId]).filter(Boolean),
      EFFORT_TAG[recommendation.effort],
    ]

    return [{ key: recommendation.id, type: recommendation.type, ...copy, values, tags }]
  })
